import { createSelector } from '@ngrx/store';

import { getEngineState } from '../engine';

export const selectRuntimeErrors = createSelector(getEngineState, (state) => state.runtimeErrors);
